module.exports = __webpack_public_path__ + "static/media/1.ae1deee0.jpg";